import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CursorProvider } from "./context/CursorContext";
import { CustomCursor } from "./components/CustomCursor";
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { CookieConsent } from "./components/CookieConsent";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import ForBrandsPage from "./pages/ForBrandsPage";
import CreatorsPage from "./pages/CreatorsPage";
import CommunityPage from "./pages/CommunityPage";
import GetStartedPage from "./pages/GetStartedPage";
import PartnerDealsPage from "./pages/PartnerDealsPage";
import BrandKitPage from "./pages/BrandKitPage";
import CareersPage from "./pages/CareersPage";
import NotFoundPage from "./pages/NotFoundPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (window.gtag) {
      window.gtag('event', 'page_view', { page_path: pathname });
    }
  }, [pathname]);
  return null;
};

const useRemoveBadge = () => {
  useEffect(() => {
    const removeBadge = () => {
      const badge = document.getElementById("emergent-badge");
      if (badge) badge.remove();
      document.querySelectorAll('a[href*="emergentagent"]').forEach((el) => {
        if (el.id === "emergent-badge" || el.textContent.toLowerCase().includes("emergent")) {
          el.remove();
        }
      });
    };
    removeBadge();
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);
};

const Layout = () => {
  return (
    <>
      <ScrollToTop />
      <CustomCursor />
      <Navigation />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/for-brands" element={<ForBrandsPage />} />
          <Route path="/creators" element={<CreatorsPage />} />
          <Route path="/community" element={<CommunityPage />} />
          <Route path="/get-started" element={<GetStartedPage />} />
          <Route path="/partner-deals" element={<PartnerDealsPage />} />
          <Route path="/brand" element={<BrandKitPage />} />
          <Route path="/careers" element={<CareersPage />} />
          {/* Legacy redirects */}
          <Route path="/deals" element={<ForBrandsPage />} />
          <Route path="/join" element={<GetStartedPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
      <CookieConsent />
      <Toaster theme="dark" />
    </>
  );
};

function App() {
  useRemoveBadge();
  return (
    <ErrorBoundary>
      <CursorProvider>
        <BrowserRouter>
          <Layout />
        </BrowserRouter>
      </CursorProvider>
    </ErrorBoundary>
  );
}

export default App;
